import { connect } from 'react-redux';
import TitleBar from './TitleBar';
import { openExportDialog } from '../actions/exportDialog';
import { openDataSettingsDialog } from '../actions/dataSettingsDialog';
import { getDataSettingsDialogOpened } from '../selectors/dataSettingsDialog';

export default connect(
  state => ({
    isDataSettingsDialogOpened: getDataSettingsDialogOpened(state),
  }),
  {
    openDataSettingsDialog,
    openExportDialog,
  },
)(TitleBar);



// WEBPACK FOOTER //
// ./src/components/TitleBarContainer.jsx